import { AnalyticsSummaryBase } from "@src/features/ai/components/usages/AnalyticsSummaryBase";
import { useAnalyticsSummary } from "@src/features/ai/components/usages/useAnalyticsSummary";

interface AnalyticsSummaryProps {
  summaryData: ReturnType<typeof useAnalyticsSummary>;
}

export const MobileAnalyticsAISummary: React.FC<AnalyticsSummaryProps> = ({
  summaryData,
}: AnalyticsSummaryProps) => {
  if (!summaryData.hasValidAuth) {
    return null;
  }

  return (
    <AnalyticsSummaryBase
      title={summaryData.title || "Results Summary"}
      summary={summaryData.summaryText}
      isLoading={summaryData.isLoading}
      errorMessage={summaryData.errorMessage}
      timestamp={summaryData.timestamp}
      formatTimestamp={summaryData.formatTimestamp}
      onCopy={summaryData.handleCopyToClipboard}
      copyFeedback={summaryData.copyFeedback}
      onRefresh={summaryData.handleRefresh}
      refreshDisabled={summaryData.refreshDisabled}
      refreshTooltip={summaryData.refreshTooltip}
      footerSessionId={summaryData.sessionId}
      footerFeature="analytics"
      footerFeedbackTarget={summaryData.footerFeedbackTarget}
      footerWorkflowId={summaryData.footerWorkflowId}
      titleVariant="h3"
      titleWidth={220}
    />
  );
};
